// extracted by mini-css-extract-plugin
export default {"button":"button_button__qYzP1","buttonBordered":"button_buttonBordered__I5Lsm"};